import { Catalogue, Solution } from '../types';
import { getCatalogueItemFromCatalogue } from './get-device-from-catalogue';

export function getTotalDevicesFromSolution(solutions: Solution[], catalogue: Catalogue): number {
  return solutions.reduce<number>((total, solution) => {
    const catalogueItem = getCatalogueItemFromCatalogue(
      catalogue,
      solution.productId,
      solution.acquiringChannel,
    );

    if (!catalogueItem) {
      return 0;
    }

    return total + solution.quantity;
  }, 0);
}